import { APP_VERSION } from "appVersion.js";

import { getSettingsPagePath } from "utils/router.utils";
import { userProfileStrings } from "constants/constantStrings";
import ROUTES_PATH, { SETTINGS_PAGES } from "constants/pages.constant";

import ManageUsersIcon from "assets/UserProfile/add_User.svg";
import UserManualIcon from "assets/UserProfile/document_Description.svg";
import LogoutIcon from "assets/UserProfile/logout.svg";
import NotificationSettingsIcon from "assets/UserProfile/notification_Settings.svg";
import SystemAndDevicesIcon from "assets/UserProfile/system_and_Device.svg";
import AccountSettingIcon from "assets/UserProfile/user_Settings.svg";

import LaunchManualIcon from "../../../assets/UserProfile/launch.svg";

export const getUserMenuOptions = (isAuthorized, hasSystemsAccess, isAdmin) => [
  {
    groupName: userProfileStrings.branding,
    isVisible: true,
    items: [
      {
        id: "app_version",
        isVisible: true,
        isDescriptionOnly: true,
        page: userProfileStrings.appVersion.replace("%", `${APP_VERSION}`)
      }
    ]
  },
  {
    groupName: "",
    isVisible: isAuthorized,
    items: [
      {
        id: SETTINGS_PAGES.ACCOUNT,
        page: userProfileStrings.accountSetting,
        pathname: getSettingsPagePath("ACCOUNT"),
        icon: AccountSettingIcon,
        isVisible: true
      },
      {
        id: SETTINGS_PAGES.NOTIFICATION,
        page: userProfileStrings.notificationSetting,
        pathname: getSettingsPagePath("NOTIFICATION"),
        icon: NotificationSettingsIcon,
        isVisible: true
      }
    ]
  },
  {
    groupName: userProfileStrings.adminSettings,
    isVisible: isAuthorized && hasSystemsAccess && isAdmin,
    items: [
      {
        id: SETTINGS_PAGES.USERS,
        page: userProfileStrings.manageUsers,
        pathname: getSettingsPagePath("USERS"),
        isVisible: true,
        icon: ManageUsersIcon
      },
      {
        id: SETTINGS_PAGES.SYSTEMS,
        page: userProfileStrings.systems,
        pathname: getSettingsPagePath("SYSTEMS"),
        isVisible: true,
        icon: SystemAndDevicesIcon
      }
    ]
  },
  {
    groupName: userProfileStrings.help,
    isVisible: isAuthorized,
    items: [
      {
        id: SETTINGS_PAGES.USERGUIDE,
        name: "USER_MANUAL",
        page: userProfileStrings.userGuide,
        isVisible: true,
        icon: UserManualIcon,
        secondaryIcon: LaunchManualIcon
      }
    ]
  },
  {
    groupName: null,
    isVisible: true,
    items: [
      {
        id: SETTINGS_PAGES.LOGOUT,
        pathname: ROUTES_PATH.LOGOUT,
        page: userProfileStrings.logout,
        isVisible: true,
        icon: LogoutIcon
      }
    ]
  }
];
